import { Component, h } from 'preact';
import cx from 'classnames';


export enum DocumentTabID {
  NAMES,
  TERMS,
  REQUESTS
};

interface InqDocumentModalTabsProps {
  activeTab: DocumentTabID;

  onTabClick: (tabId: DocumentTabID) => void;
}


export class InqDocumentModalTabs extends Component<InqDocumentModalTabsProps> {
  render(props: InqDocumentModalTabsProps) {
    return (
      <div className="hi-docmodal__tab-button-row">
        <button className={ cx('hi-docmodal__tab-button', {
          active: props.activeTab === DocumentTabID.NAMES
        }) } onClick={ () => props.onTabClick(DocumentTabID.NAMES) }>
          Names
        </button>
        <button className={ cx('hi-docmodal__tab-button', {
          active: props.activeTab === DocumentTabID.TERMS
        }) } onClick={ () => props.onTabClick(DocumentTabID.TERMS) }>
          Terms
        </button>
        <button className={ cx('hi-docmodal__tab-button', {
          active: props.activeTab === DocumentTabID.REQUESTS
        }) } onClick={ () => props.onTabClick(DocumentTabID.REQUESTS) }>
          Additional Requests
        </button>
        <div className="hi-docmodal__tab-button-row-filler" />
      </div>
    )
  }
}
